import { Text, Modal, Button } from '@querodelivery/uni-react';
import styles from './import-fare-select-modal.module.scss';

import { DropdownInput } from '@/_components/dropdown-input/dropdown-input';
import type { IDropdownOptions } from '@/Interfaces/Data';

interface ImportFareSelectModalProps {
  open: boolean;
  onClose(): void;
  onConfirm(): void;
  options: IDropdownOptions[];
  selectedPlaceId?: string;
  onSelectionChange(value: string | string[]): void;
  loading?: boolean;
}

export function ImportFareSelectModal({
  open,
  onClose,
  onConfirm,
  options,
  selectedPlaceId,
  onSelectionChange,
  loading = false,
}: ImportFareSelectModalProps) {
  if (!open) {
    return null;
  }

  const hasOptions = options.length > 0;

  return (
    <Modal
      header="Importar tarifa"
      isOpen={open}
      onClose={onClose}
      width="32rem"
    >
      <div className={styles.content}>
        <Text>Selecione o estabelecimento para importar a tarifa:</Text>

        <DropdownInput
          search
          clearable
          placeholder="Digite o nome do estabelecimento"
          options={options}
          value={selectedPlaceId || ''}
          onChange={onSelectionChange}
          loading={loading}
        />

        {!loading && !hasOptions ? (
          <Text>Nenhum estabelecimento encontrado para esta cidade.</Text>
        ) : null}

        <div className={styles.actions}>
          <Button variant="outline" size="lg" type="button" onClick={onClose}>
            cancelar
          </Button>

          <Button
            type="button"
            size="lg"
            onClick={onConfirm}
            disabled={!selectedPlaceId || !hasOptions}
          >
            selecionar
          </Button>
        </div>
      </div>
    </Modal>
  );
}
